import React from 'react'
import {checkColumn} from './checkColumn'
import {
  Row,
  Required,
  ColumnName,
  ColumnType,
  ColumnStatus,
  ColumnDescription
} from './containers'

type DescriptionTableRowProps = {
  title: string
  description: string
  type: string
  fileColumnNames: string[]
  required?: boolean
}

export const DescriptionTableRow = (props: DescriptionTableRowProps) => {
  const {title, description, type, fileColumnNames, required} = props
  const status = checkColumn(title.toLowerCase(), fileColumnNames)
  const {text, className} = status

  return (
    <Row>
      <ColumnName>
        {title}
        {required ? <Required>&nbsp;*</Required> : ''}
      </ColumnName>
      <ColumnType>{type}</ColumnType>
      <ColumnStatus className={className}>{`${text}`}</ColumnStatus>
      <ColumnDescription>{description}</ColumnDescription>
    </Row>
  )
}
